import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ServiceaftaleDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/serviceaftale-dto';
import { ServiceaftaleTagDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/serviceaftale-tag-dto';
import { ServiceAftaleService } from 'src/app/api/services';
import { EGIS_SERVICE_CALLER } from 'src/app/constants';
import { ErrorHandlerService } from 'src/app/services/error-handler.service';

@Component({
    selector: 'app-edit-tags',
    templateUrl: './edit-tags.component.html',
    styleUrls: ['./edit-tags.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EditTagsComponent implements OnInit, OnDestroy {
  tags: ServiceaftaleTagDto[];
  selectedTags: ServiceaftaleTagDto[];

  private _serviceaftale: ServiceaftaleDto;
  @Input() set serviceaftale(serviceaftale: ServiceaftaleDto) {
    this._serviceaftale = serviceaftale;
    if (serviceaftale) {
      this.updateTags();
    }
  }

  unsubscribe$ = new Subject<void>();

  constructor(private serviceaftaleService: ServiceAftaleService, private errorHandler: ErrorHandlerService) {}

  ngOnInit(): void {}

  updateTags() {
    this.selectedTags = this._serviceaftale.serviceaftaleTags;
    this.serviceaftaleService
      .getServiceaftaleTags({
        caller: EGIS_SERVICE_CALLER,
      })
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(
        (tags: ServiceaftaleTagDto[]) => {
          for (var i = tags.length - 1; i >= 0; i--) {
            for (var j = 0; j < this.selectedTags.length; j++) {
              if (tags[i] && tags[i].id === this.selectedTags[j].id) {
                tags.splice(i, 1);
              }
            }
          }
          this.tags = tags;
        },
        (error: HttpErrorResponse) => {
          this.errorHandler.HandleError(error);
        }
      );
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.unsubscribe();
  }

  remove(tag: ServiceaftaleTagDto): void {
    const index = this.selectedTags.indexOf(tag);
    if (index >= 0) {
      this.selectedTags.splice(index, 1);
      this.tags.push(tag);
    }
    this.saveTags();
  }

  add(tagId: number): void {
    const tag = this.tags.find((x) => x.id == tagId);
    this.selectedTags.push(tag);
    const index = this.tags.indexOf(tag);
    if (index >= 0) {
      this.tags.splice(index, 1);
    }

    this.saveTags();
  }

  saveTags() {
    const ids = this.selectedTags.map((x) => x.id);
    this.serviceaftaleService
      .updateTags({
        caller: '',
        body: {
          serviceaftaleId: this._serviceaftale.id,
          tagIds: ids,
          rowVersion: this._serviceaftale.rowVersion,
        },
      })
      .subscribe();
  }
}
